import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=279096e7&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=ts"
export * from "./Demo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279096e7",
  null
  
)

export default component.exports